import React from "react";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { Alert, Button, Box, Typography } from "@mui/material";
import { formatDate } from '/@/app/utils';
import { TextField } from '@mui/material';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import { Spinner } from "/@/app/components/Spinner";

dayjs.extend(utc);
dayjs.extend(timezone);


//
// For better user experience - suggest dates that will make a nice diagram.
//
const suggestDate = (parameter) => {
    if (parameter.measurements.length === 0) {
        return dayjs();
    }
    // here we find a recent date, but at least 1 day away from any of the measurements.
    // Walk back from today, 1 day per iteration, until we find a date that 1 day far from any measurement.
    let recentDate = dayjs();
    let found = false;
    while (!found) {
        found = true;
        for (let m of parameter.measurements) {
            if (recentDate.diff(dayjs(m.made_at), 'days') === 0) {
                found = false;
                break;
            }
        }
        if (!found) {
            recentDate = recentDate.subtract(1, 'day');
        }
    }
    return recentDate;
}


export const AddChangeMeasurement = observer(({ state, onDone }) => {
    const textFieldRef = useRef(null);
    const [value, setValue] = useState(state.value);
    const [madeAt, setMadeAt] = useState(
        state.made_at ? dayjs(state.made_at) : suggestDate(state.boundParameter)
    );

    const isNew = state.id === null;
    const isSaving = state.saveStatus === "saving";

    useEffect(() => {
        if (textFieldRef.current) {
            textFieldRef.current.focus();
        }
    }, []);

    const doSave = () => {
        const browserTimezone = dayjs.tz.guess();
        const isoFormattedDate = madeAt.tz(browserTimezone).toISOString();

        state.save({
            value: value,
            made_at: isoFormattedDate,
        }).then(() => {
            onDone();
        });
    }

    if (state.value_is_computed) {
        return (
            <>
                <Alert severity="error">
                    Это вычисляемый параметр из панели! Изменить его нельзя.
                </Alert>
            </>
        );
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                {state.id === null
                    ? <>Добавить замер</>
                    : <>Изменить замер</>
                }
            </Typography>

            <Box sx={{ mt: 2, display: "flex", flexFlow: "column nowrap", gap: 1, alignItems: "center" }}>
                {state.panel_id &&
                    <Alert severity="warning">
                        <b>Замер привязан к панели от {formatDate(state.made_at)}</b>!
                        При изменении, панель будет пересчитана
                        по последнему обновлению Nestarenie.Expert.
                    </Alert>
                }
                <TextField
                    label={state.boundParameter.name}
                    variant="outlined"
                    inputRef={textFieldRef}
                    value={value === null ? "" : value}
                    onChange={e => setValue(e.target.value)}
                    sx={{
                        input: {
                            textAlign: 'center',
                        },
                    }}
                />
                <Box>{state.boundParameter.unit}</Box>
                {/* TODO units selector */}

                <Box>
                    {state.panel_id
                        ? formatDate(madeAt)
                        : <MobileDateTimePicker
                            onChange={(newValue) => {setMadeAt(newValue);}}
                            label="Дата измерения или анализа"
                            value={madeAt}
                        />
                    }
                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={doSave}
                    disabled={isSaving}
                >
                    {isSaving
                        ? <Spinner size={30} sx={{ color: "white" }}/>
                        : "Сохранить"
                    }
                </Button>
            </Box>
        </>
    );
});
